import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';
import Load from 'components/Load';

const AsyncFeedbackForm = Load(() => import(/* webpackChunkName: "feedback-form" */'./components/FeedbackForm'), {}, true);

const RateAppRoute = <Route key={'rate-app-feedback'} path={`${basePath}/rate-app/feedback`} component={AsyncFeedbackForm} />;

export default RateAppRoute;
